import base from "./base";
import axios from "@/request/request";

const api = {
  getData() {
    return axios.post(base.indexList)
  },
  // 获取分页列表数据------------
  getCategoryInfo(params) {
    return axios.post(base.getCategoryInfo, params)
  },
  // 获取详情-----------
  getProductInfo(params) {
    return axios.post(base.getProductInfo, params)
  },
  // 新闻详情
  getNewInfo(params) {
    return axios.post(base.getNewInfo, params)
  },
  // 留言
  message(params) {
    return axios.post(base.message, params)
  },
  // 首页
  getIndexMenu() {
    return axios.post(base.indexMenu)
  },
  // 合作伙伴
  aboutList(params) {
    return axios.post(base.aboutList, params)
  },
  //注册
  register(params) {
    return axios.post(base.register, params)
  },
  //登录
  login(params) {
    return axios.post(base.login, params)
  },
  //获取商品列表数据
  getShopProductList() {
    return axios.post(base.getShopProductList)
  },

  // 商城商品
  shopList(params) {
    return axios.post(base.shopList, params)
  },
  // 微信支付
  weixinpay(params){
    return axios.post(base.getQrcode, params)
  }

};

export default api;
export const baseUrl = "https://www.zisonai.com"
// export const baseUrl = "http://192.168.0.188:81"